import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal"
import { useModal } from "../../../contexts/ModalContext"
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import { useParams } from "react-router-dom";
import useApi from "../../../hooks/useApi";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";
import styled from "styled-components";

const CheckboxContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 20px 0;

    h3 {
        margin: 0;
        font-size: 16px;
        color: #555;
        text-align: center;
    }
`
const CheckboxWrapper = styled.div`
    margin: auto;
    display: flex;
    align-items: center;
    gap: 20px;
    color: #333;
    label {
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        input {
            width: 16px;
            height: 16px;
        }
    }
`

const ModalNovoAditivo = ({ fetchData }) => {

    const { id } = useParams();

    const api = useApi();
    const { closeModal } = useModal();

    const [formValues, setFormValues] = useState({
        tipoAditivo: "",
        valorFaturamento: 0,
        valorFaturamentoDireto: 0,
        descricao: "",
        observacoes: "",
        dataContrato: "",
        pc_pendente: false,
        proposta_pendente: false,
        contrato_pendente: false
    })

    const [arquivos, setArquivos] = useState([]);

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormValues((prev) => {
            if (name === "valorFaturamento" || name === "valorFaturamentoDireto") {
                return { ...prev, [name]: parseCentsFromInput(value) }
            }
            return { ...prev, [name]: value.toUpperCase() }
        })

    }

    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setSaving(true);

            const formData = new FormData();

            formData.append("idPedidoCompra", id);
            formData.append("tipoAditivo", formValues.tipoAditivo);
            formData.append("valorFaturamento", formValues.valorFaturamento);
            formData.append("valorFaturamentoDireto", formValues.valorFaturamentoDireto);
            formData.append("descricao", formValues.descricao);
            formData.append("observacoes", formValues.observacoes);
            formData.append("dataContrato", formValues.dataContrato);
            formData.append("pc_pendente", formValues.pc_pendente);
            formData.append("proposta_pendente", formValues.proposta_pendente);
            formData.append("contrato_pendente", formValues.contrato_pendente);

            arquivos.forEach((item) => {
                formData.append("files[]", item.file);
            });

            const { data } = await api.post("/Painel/API/ControleMedicao/CreateAditivo/", formData);
            console.log(data);

            fetchData();
            closeModal();

        } catch (e) {

            console.error(e);

        } finally {

            setSaving(false);

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="TIPO DO ADITIVO"
                            type="select"
                            options={[
                                "ADITIVO",
                                "REAJUSTE",
                                "TAKE OFF"
                            ]}
                            valor={formValues.tipoAditivo}
                            name="tipoAditivo"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="VALOR FATURAMENTO"
                            type="text"
                            inputMode="numeric"
                            placeholder="R$ 0,00"
                            valor={formatBRLFromCents(formValues.valorFaturamento)}
                            name="valorFaturamento"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="VALOR FATURAMENTO DIRETO"
                            type="text"
                            inputMode="numeric"
                            placeholder="R$ 0,00"
                            valor={formatBRLFromCents(formValues.valorFaturamentoDireto)}
                            name="valorFaturamentoDireto"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="VALOR TOTAL"
                            type="text"
                            //Somar valores de faturamento e faturamento direto e formatar para BRL
                            valor={formatBRLFromCents(formValues.valorFaturamento + formValues.valorFaturamentoDireto)}
                            readOnly
                        />
                        <FormComp
                            title="DESCRIÇÃO"
                            type="text"
                            valor={formValues.descricao}
                            name="descricao"
                            changeFunc={handleChange}
                            required
                        />
                        <FormComp
                            title="OBSERVAÇÕES"
                            type="textarea"
                            valor={formValues.observacoes}
                            name="observacoes"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="DATA DO CONTRATO"
                            type="date"
                            valor={formValues.dataContrato}
                            name="dataContrato"
                            changeFunc={handleChange}
                        />
                        <MultiFileUploader
                            files={arquivos}
                            setFiles={setArquivos}
                        />
                        <CheckboxContainer>
                            <h3>ARQUIVO PENDENTE</h3>
                            <CheckboxWrapper>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.pc_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, pc_pendente: e.target.checked })}
                                    />
                                    PEDIDO DE COMPRA
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.proposta_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, proposta_pendente: e.target.checked })}
                                    />
                                    PROPOSTA
                                </label>
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={formValues.contrato_pendente}
                                        onChange={(e) => setFormValues({ ...formValues, contrato_pendente: e.target.checked })}
                                    />
                                    CONTRATO
                                </label>
                            </CheckboxWrapper>
                        </CheckboxContainer>
                        <FormComp
                            type="submit"
                            valor={saving ? "SALVANDO..." : "SALVAR"}
                            disabled={saving}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoAditivo;